'use client';

import { c as _c } from "react/compiler-runtime";
import LogoOverlayRecommendationCardShell from '@/app/[locale]/(worlds)/[roomId]/components/LogoOverlayRecommendationCardShell';
type LogoOverlayViewAllCardProps = {
  label: string;
  href: string;
};
export default function LogoOverlayViewAllCard(t0) {
  const $ = _c(5);
  const {
    label,
    href
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <div className="flex h-full w-full flex-col items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/10 p-3 text-center transition-[background-color] duration-150 hover:bg-white/25"><span className="text-xs leading-tight font-medium text-white">{label}</span></div>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== href || $[3] !== t1) {
    t2 = <LogoOverlayRecommendationCardShell href={href} external={true} className="self-stretch">{t1}</LogoOverlayRecommendationCardShell>;
    $[2] = href;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}